<template>
    <div>
        <v-col cols="12" sm="12">
            <v-radio-group v-model="finishModel" row>
                <v-radio label="Louvers" value="louvers"></v-radio>
                <v-radio label="HPL" value="hpl"></v-radio>
                <v-radio label="ACS Aluminum" value="acsAluminum"></v-radio>
                <v-radio label="Brake Metals" value="brakeMetals"></v-radio>
            </v-radio-group>
        </v-col>
        <Finish v-if="finishModel === 'louvers'" :setting="setting" />
        <FinishHPL v-if="finishModel === 'hpl'" :setting="setting" />
        <FinishAluminum v-if="finishModel === 'acsAluminum'" :setting="setting" />
        <FinishBrakeMetals v-if="finishModel === 'brakeMetals'" :setting="setting" />
    </div>
</template>

<script>
import Finish from '@/components/Settings/Clients/Finish.vue'
import FinishHPL from '@/components/Settings/Clients/FinishHPL.vue'
import FinishAluminum from '@/components/Settings/Clients/FinishAluminum.vue'
import FinishBrakeMetals from '@/components/Settings/Clients/FinishBrakeMetals.vue'

export default {
    name: 'AllFinish',
    props: {
        setting: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        Finish,
        FinishHPL,
        FinishAluminum,
        FinishBrakeMetals,
    },
    data() {
        return {
            finishModel: 'louvers',
        }
    },
}
</script>
